import { logAd } from './adDiagnostics';
import { getMobileActiveCompat } from '../services/api';

const MOBILE_PLATFORMS = new Set(['android', 'ios']);

let resolveRuntime: (() => void) | null = null;
const runtimeReady = new Promise<void>((resolve) => {
  resolveRuntime = resolve;
});
let configured = false;

function platform(): string {
  return String((window as any).Telegram?.WebApp?.platform || '').toLowerCase();
}

function mountScript(source: string): void {
  const script = document.createElement('script');
  script.textContent = source;
  document.head.appendChild(script);
}

export function isMobileAdsPlatform(): boolean {
  return MOBILE_PLATFORMS.has(platform());
}

export function isMobileActiveCompatInstalled(): boolean {
  const win = window as any;
  return Boolean(win.__mobileActiveCompatInstalled && win.Telegram?.WebApp?.__mobileActiveCompatView);
}

export function configureAdsRuntime(): void {
  if (configured) return;
  configured = true;

  const currentPlatform = platform();
  const finish = () => resolveRuntime?.();
  if (!isMobileAdsPlatform()) {
    logAd('ok', 'runtime', 'Мост жизненного цикла не нужен вне Telegram iOS/Android', {
      platform: currentPlatform,
    });
    finish();
    return;
  }

  getMobileActiveCompat(currentPlatform)
    .then(mountScript)
    .then(() => {
      const installed = isMobileActiveCompatInstalled();
      logAd(installed ? 'ok' : 'warn', 'runtime', installed
        ? 'Мост жизненного цикла установлен до SDK'
        : 'Мост жизненного цикла не установился', {
        platform: currentPlatform,
        compatInstalled: installed,
      });
    })
    .catch((error) => {
      logAd('warn', 'runtime', 'Мост жизненного цикла недоступен, SDK продолжат загрузку', {
        platform: currentPlatform,
        error: String(error),
      });
    })
    .finally(finish);
}

export async function adsRuntimeReady(): Promise<void> {
  await runtimeReady;
}
